export default "__VITE_ASSET__269b3f88__"